import { injectable } from 'tsyringe';
import { NoRecommendationReasons } from '../no-recommendations-reasons.enums';
import { PersistentStorageService } from '../../persistent-storage-service/persistent-storage.service';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  conditionType,
  ConditionType,
} from './decrators/condition-type.decorator';
import { LoggerService } from '../../../../shared/services/logger.service';
import { Game } from '../../../models/game.model';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Global)
export class GlobalConditionOfferApprovalRequired implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'GlobalConditionOfferApprovalRequired',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly persistentLocalStorage: PersistentStorageService,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  shouldSkip(context: ConditionContext) {
    const { game } = context;

    if (!game?.offers || game.offers.length === 0) {
      return true;
    }

    return false;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { game } = context;

    const dismissedTimestamp = this.getApplicationDismissedTimestamp(game);
    if (!dismissedTimestamp || dismissedTimestamp === 0) {
      return [true];
    }

    this.logger.info(
      `Game [${game.id}] requires offer approval but offer was previously dismissed.`,
    );
    return [false, NoRecommendationReasons.OfferNotApproved];
  }

  // ---------------------------------------------------------------------------
  private getApplicationDismissedTimestamp(game: Game): number {
    const displayedPromotion =
      this.persistentLocalStorage.getDisplayedPromotionOfferInfo(game);

    return displayedPromotion?.dismissedTimestamp ?? 0;
  }
}
